import script from "./PatientRecordSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientRecordSummary.vue?vue&type=script&setup=true&lang=js"

import "./PatientRecordSummary.vue?vue&type=style&index=0&id=2f65591a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f65591a"]])

export default __exports__